<template>
  <router-view />
</template>
<script lang="ts" setup>
// import { useAuthStore } from '@/pinia/authorization/useAuthStore'
// import { storeToRefs } from 'pinia'
// import { onMounted } from 'vue'
//
// const { init, authLogout } = useAuthStore()
// const { menuItems, userData } = storeToRefs(useAuthStore())
// onMounted(() => {
//   init()
// })
</script>
<style lang="scss"></style>
